import { combineReducers } from 'redux';

import AddressSlice, { namespace as AddressNamespace } from './address/slice';
import ConnectionSlice, { namespace as ConnectionNamespace } from './connection/slice';
import AuthenticationSlice, { namespace as AuthenticationNamespace } from './authentication/slice';
import ConfigSlice, { namespace as ConfigNamespace } from './config/slice';

export default combineReducers({
  [AddressNamespace]: AddressSlice,
  [ConnectionNamespace]: ConnectionSlice,
  [AuthenticationNamespace]: AuthenticationSlice,
  [ConfigNamespace]: ConfigSlice,
});
